import { render, staticRenderFns } from "./ClubsTable.vue?vue&type=template&id=8123b4cc&scoped=true&"
import script from "./ClubsTable.vue?vue&type=script&lang=js&"
export * from "./ClubsTable.vue?vue&type=script&lang=js&"
import style0 from "./ClubsTable.vue?vue&type=style&index=0&id=8123b4cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8123b4cc",
  null
  
)

export default component.exports